export const TIME_PICKER_MAX_LENGTH = 5;
